import { inject, Injectable } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';
import { AuthenticatedUser } from '@dashboard_models/dashboard-owner-user';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { AuthService } from '@services/auth/auth.service';

interface CrispDataObj {
    business_type?: string;
    account_id?: string;
    customer_uid?: string;
    stripe_link?: string;
    db_link?: string;
    [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ChatbotService {
    authenticatedUser?: AuthenticatedUser;
    private authService: AuthService = inject(AuthService);
    private localStorageService: LocalStorageService = inject(LocalStorageService);
    async setupChatBot(): Promise<void> {
        this.authenticatedUser = this.localStorageService.getItem('authenticatedUser') ?? undefined;
        const authenticatedUser = this.authenticatedUser;
        if (!authenticatedUser) {
            return;
        }

        const data = this.authService.customerFirestore()?.shallow_account_details;
        const _obj: CrispDataObj = {};
        if (data) {
            if (data.name && typeof data.name === 'string') {
                Crisp.user.setNickname(data.name);
            }
            _obj.business_type = data.business_type;
            _obj.account_id = data.account_id;
            _obj.customer_uid = authenticatedUser.uid;
            _obj.stripe_link = `https://dashboard.stripe.com/connect/accounts/${data.account_id}/activity`;
            _obj.db_link = `https://console.firebase.google.com/u/0/project/airwallet-685ff/database/airwallet-685ff/data/~2Fcustomers~2F${authenticatedUser.uid}`;
            Crisp.session.setData(_obj);
        } else {
            Crisp.session.setData({ customer_uid: authenticatedUser.uid });
        }
        Crisp.user.setEmail(authenticatedUser.email);
    }
}
